//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-account-updated-message-box',
}
